import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import Argon from "./plugins/argon-kit";
import store from "./store";
import VueToast from "vue-toast-notification";
import "vue-toast-notification/dist/theme-sugar.css";

Vue.config.productionTip = false;
Vue.use(Argon);
var VueScrollTo = require("vue-scrollto");
Vue.use(VueScrollTo);
Vue.use(VueToast);

if (window.location.protocol != "https:") {
  window.location.href = "https://www.telereglement.fr/";
}
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
